/*
This file is for the connection f the components of Wind of us and the provider with a buttonn
*/

export const windGlobalModule = {
  namespaced: true,

  state: {
    isRelativeWind: false,
  },

  mutations: {
    SET_WIND_MODE(state, value) {
      state.isRelativeWind = value;
    },
  },

  actions: {
    toggleWindMode({ commit, state }) {
      commit("SET_WIND_MODE", !state.isRelativeWind);
    },
  },
};
